/* eslint-disable @typescript-eslint/no-floating-promises */

'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { CheckoutSkeleton } from 'components/ui/organisms/checkout/skeletons';
import { redirectToCheckout } from 'utils/redirect-to-checkout';
import { useLoadCart } from 'frontastic/hooks';

export const LoadCartTastic = () => {
  const { loadCartForCourses, loadCartForProgram } = useLoadCart();
  const searchParams = useSearchParams();
  const router = useRouter();
  const courseRunKeys = searchParams.getAll('course_run_key');
  const programId = searchParams.get('bundle');
  const discountCode = searchParams.get('code') ?? undefined;

  useEffect(() => {
    (async () => {
      if (programId) {
        await loadCartForProgram(programId, discountCode);
        redirectToCheckout(router, { programId });
      } else if (courseRunKeys.length > 0) {
        await loadCartForCourses(courseRunKeys, discountCode);
        redirectToCheckout(router);
      } else {
        redirectToCheckout(router);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <CheckoutSkeleton />;
};
